var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-competence-cards-page" },
    [
      _c("competence-cards-data-provider", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(dataProvider) {
              return _c(
                "div",
                { staticClass: "o-width-limiter" },
                [
                  _c("can", { attrs: { i: "manage", a: "CompetenceCard" } }, [
                    _c(
                      "div",
                      { staticClass: "t-margin-bottom-m" },
                      [
                        _vm.displayCreateButton
                          ? _c(
                              "router-link",
                              {
                                staticClass: "c-button c-button--primary",
                                attrs: { to: "/create-competence-card/" }
                              },
                              [_vm._v("Lägg till medarbetare")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.displayBatchAddCourseButton
                          ? _c(
                              "router-link",
                              {
                                staticClass: "c-button c-button--primary",
                                attrs: { to: "/batch-competence-cards/" }
                              },
                              [_vm._v("Lägg till kurs för flera medarbetare")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.displayBatchAddCompetenceButton
                          ? _c(
                              "a",
                              {
                                staticClass: "c-button c-button--primary",
                                attrs: { href: _vm.competenceBatchUrl }
                              },
                              [
                                _vm._v(
                                  "Lägg till kompetens för flera medarbetare"
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.displayExportPdfsButton
                          ? _c(
                              "a",
                              {
                                staticClass: "c-button c-button--primary",
                                attrs: { href: _vm.exportPdfsUrl }
                              },
                              [_vm._v("Skriv ut kompetenskort")]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "[ c-island c-island--large@lg ]  t-background-white-grey t-margin-bottom-s"
                      },
                      [
                        _c("competence-cards-filters"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "t-margin-top-s" },
                          [
                            _c("competence-cards-list", {
                              attrs: {
                                "competence-cards":
                                  dataProvider.competenceCardRows,
                                loading: dataProvider.loading
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.canManageCompetenceCards
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "t-text-style-beta t-margin-bottom-s t-margin-top-s"
                        },
                        [
                          _vm._v(
                            "\n                För att få tillgång till IN Kompetensverktyg behöver du vara administratör av tjänsten."
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Kontakta tjänsteadministratören på ditt företag om du vill se din kompetensprofil eller skriva ut ett kompetenskort.\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }